export default __webpack_public_path__ + "static/image-star-f7d560adef7b4ead9ea3805ee68c8b4e.png";